import React, { PureComponent } from "react";
import { withAppState } from "./../../shared/containers/containerAppState";
import Icon from "./../../shared/items/static/icon";
import TooltipWrapper from "./../../shared/items/contols/tooltipWrapper";

import styles from "./sideBar.module.scss";

class SideBarControl extends PureComponent {
  componentDidMount() {
    const { isCarsSecondSideBarOpen, onCloseCarsSecondSideBar } = this.props;

    if (isCarsSecondSideBarOpen) onCloseCarsSecondSideBar();
  }

  handleSideBarClose() {
    const {
      isCarsSecondSideBarOpen,
      isDriversSecondBarOpen,
      onCloseSideBarAction,
      onCloseCarsSecondSideBar,
      onCloseDriversSecondSideBar,
    } = this.props;

    onCloseSideBarAction();
    if (isCarsSecondSideBarOpen) onCloseCarsSecondSideBar();

    if (isDriversSecondBarOpen) onCloseDriversSecondSideBar();
  }

  render() {
    const { isSideBarOpen, onOpenSideBarAction, TitleClosed } = this.props;

    return (
      <div className={isSideBarOpen ? styles.sideBar_open : styles.sideBar_closed}>
        <button
          className={isSideBarOpen ? styles.buttonToggleOpen_barOpen : styles.buttonToggleOpen_barClosed}
          onClick={isSideBarOpen ? this.handleSideBarClose.bind(this) : onOpenSideBarAction}
        >
          <TooltipWrapper title={isSideBarOpen ? "Свернуть панель" : "Развернуть панель"} position="right">
            <div className={styles.container_sideBarIcon}>
              <Icon name="forward" />
            </div>
          </TooltipWrapper>
        </button>
        <div className={styles.container_title}>{TitleClosed}</div>
        <div className={styles.container_sideBarInner}>{this.props.children}</div>
      </div>
    );
  }
}

export default withAppState(SideBarControl);
